// // import React from "react";
// // import { useForm } from "react-hook-form";
// // import styles from "./EventForm.module.css";

// // const EventRegistration = () => {
// //   const {
// //     register,
// //     handleSubmit,
// //     setValue,
// //     watch,
// //     formState: { errors },
// //   } = useForm({
// //     defaultValues: {
// //       name: "M/S COMPANY",
// //       mobile: "9005756789",
// //       email: "vikramravgroup@gmail.com",
// //       tickets: 0,
// //       paymentMode: "main_wallet",
// //     },
// //   });

// //   const selectedPayment = watch("paymentMode");

// //   const onSubmit = (data) => {
// //     console.log("Form Data Submitted:", data);
// //     alert("Registration Reserved!");
// //   };

// //   return (
// //     <div className=" h-100">
// //       <div className={styles.cardContainer}>
// //         <h4 className="text-center mb-4 fw-bold">
// //           Fill the Details to Register for the Event
// //         </h4>
// //         <form onSubmit={handleSubmit(onSubmit)}>
// //           {/* Event Selection */}
// //           <div className="mb-4">
// //             <label className="form-label small fw-bold">
// //               Select Event to Register{" "}
// //               <span className={styles.required}>*</span>
// //             </label>
// //             <select
// //               {...register("event", { required: true })}
// //               className={`form-select ${errors.event ? "is-invalid" : ""}`}
// //             >
// //               <option value="">-- Select Event --</option>
// //               <option value="conf_2024">Annual Tech Conference 2026</option>
// //               <option value="workshop">UI/UX Workshop</option>
// //             </select>
// //           </div>

// //           <h5 className={styles.sectionTitle}>Primary Person Details</h5>

// //           <div className="row g-3 mb-4">
// //             {/* Name */}
// //             <div className="col-md-3">
// //               <label className="form-label small fw-bold">
// //                 Name <span className={styles.required}>*</span>
// //               </label>
// //               <input
// //                 type="text"
// //                 className="form-control"
// //                 {...register("name", { required: true })}
// //               />
// //             </div>

// //             {/* Mobile */}
// //             <div className="col-md-3">
// //               <label className="form-label small fw-bold">
// //                 Mobile Number <span className={styles.required}>*</span>
// //               </label>
// //               <input
// //                 type="tel"
// //                 className="form-control"
// //                 {...register("mobile", { required: true })}
// //               />
// //             </div>

// //             {/* Email */}
// //             <div className="col-md-4">
// //               <label className="form-label small fw-bold">Email</label>
// //               <input
// //                 type="email"
// //                 className="form-control"
// //                 {...register("email")}
// //               />
// //             </div>

// //             {/* No. of Tickets */}
// //             <div className="col-md-2">
// //               <label className="form-label small fw-bold">
// //                 No. of Ticket <span className={styles.required}>*</span>
// //               </label>
// //               <input
// //                 type="number"
// //                 className="form-control"
// //                 {...register("tickets", { min: 1 })}
// //               />
// //             </div>
// //           </div>

// //           {/* Payment Mode Selection */}
// //           <div className="mb-4">
// //             <label className="form-label small fw-bold">
// //               Payment Mode <span className={styles.required}>*</span>
// //             </label>
// //             <div className="row g-3">
// //               <div className="col-md-4">
// //                 <div
// //                   className={`${styles.paymentOption} ${styles.walletMain}`}
// //                   onClick={() => setValue("paymentMode", "main_wallet")}
// //                 >
// //                   Main Wallet Avail: ₹55,06,841
// //                 </div>
// //               </div>
// //               <div className="col-md-4">
// //                 <div
// //                   className={`${styles.paymentOption} ${styles.walletDiscount}`}
// //                   style={{ opacity: 0.7 }}
// //                 >
// //                   Discount Wallet Avail: ₹0
// //                 </div>
// //               </div>
// //               <div className="col-md-4">
// //                 <div
// //                   className={`${styles.paymentOption} ${styles.paymentOnline}`}
// //                   onClick={() => setValue("paymentMode", "online")}
// //                 >
// //                   Online Payment
// //                 </div>
// //               </div>
// //             </div>
// //           </div>

// //           <button type="submit" className={styles.reserveBtn}>
// //             Reserve Your Seat
// //           </button>
// //         </form>
// //       </div>
// //     </div>
// //   );
// // };

// // export default EventRegistration;

// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import styles from "./EventForm.module.css";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import useApiRequest from "../../Hooks/apiReq";

// const EventRegistration = () => {
//   const { error, loading, recallRequest, response, sendApiRequest } =
//     useApiRequest();
//   const associateProfileDetails = useSelector(
//     (state) => state.assoProfileDetails.profileDetails,
//   );
//   const [dropData, setDropDownData] = useState([]);
//   const getUpdatedEventlist = () => {
//     sendApiRequest(
//       "POST",
//       "/Dashboard/GetEventList",
//       {
//         Mode: "EVENT_DDL",
//       },
//       {
//         onSuccess: (res) => {
//           const ParsedData = res?.data?.jsonData
//             ? JSON.parse(res?.data?.jsonData)
//             : [];
//           setDropDownData(ParsedData);
//         },
//         onStatus3: () => navigate("/login"),
//       },
//     );
//   };
//   useEffect(() => getUpdatedEventlist(), []);
//   const defaultValues = {
//     name:
//       associateProfileDetails?.solutation +
//       " " +
//       associateProfileDetails?.fullName,
//     mobile: "9005756789",
//     email: "vikramravgroup@gmail.com",
//     tickets: 1,
//     paymentMode: "main_wallet",
//   };
//   console.log(defaultValues);

//   const {
//     register,
//     handleSubmit,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm({
//     defaultValues: defaultValues,
//   });
//   const selectedPayment = watch("paymentMode");

//   const onSubmit = (data) => {
//     console.log("Form Data Submitted:", data);
//     // alert("Registration Reserved!");
//     sendApiRequest(
//       "POST",
//       {},
//       {
//         onSuccess: (res) => {
//           toast.warn(res?.message || "Registration Reserved!");
//         },
//       },
//     );
//   };

//   console.log(dropData, "dro");

//   return (
//     <div className=" py-5">
//       <div className={styles.cardContainer}>
//         <h4 className="text-center mb-4 fw-bold">
//           Fill the Details to Register for the Event
//         </h4>

//         <form onSubmit={handleSubmit(onSubmit)}>
//           {/* Event Selection - Floating */}
//           <div className="form-floating mb-4">
//             <select
//               id="eventSelect"
//               {...register("event", { required: "Please select an event" })}
//               className={`form-select ${errors.event ? "is-invalid" : ""}`}
//             >
//               <option value="">-- Select Event --</option>
//               {dropData?.map((i) => (
//                 <option value="conf_2024">
//                   {i?.EventCity} ({i?.strEventDate})
//                 </option>
//               ))}
//             </select>
//             <label htmlFor="eventSelect">
//               Select Event to Register <span className="text-danger">*</span>
//             </label>
//             {errors.event && (
//               <div className="invalid-feedback">{errors.event.message}</div>
//             )}
//           </div>

//           <h5 className={styles.sectionTitle}>Primary Person Details</h5>

//           <div className="row g-3 mb-4">
//             {/* Name - Floating */}
//             <div className="col-md-3">
//               <div className="form-floating">
//                 <input
//                   id="floatName"
//                   type="text"
//                   placeholder="Name"
//                   className={`form-control ${errors.name ? "is-invalid" : ""}`}
//                   {...register("name", { required: true })}
//                 />
//                 <label htmlFor="floatName">Name *</label>
//               </div>
//             </div>

//             {/* Mobile - Floating */}
//             <div className="col-md-3">
//               <div className="form-floating">
//                 <input
//                   id="floatMobile"
//                   type="tel"
//                   placeholder="Mobile"
//                   className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
//                   {...register("mobile", { required: true })}
//                 />
//                 <label htmlFor="floatMobile">Mobile Number *</label>
//               </div>
//             </div>

//             {/* Email - Floating */}
//             <div className="col-md-4">
//               <div className="form-floating">
//                 <input
//                   id="floatEmail"
//                   type="email"
//                   placeholder="Email"
//                   className="form-control"
//                   {...register("email")}
//                 />
//                 <label htmlFor="floatEmail">Email</label>
//               </div>
//             </div>

//             {/* No. of Tickets - Floating */}
//             <div className="col-md-2">
//               <div className="form-floating">
//                 <input
//                   id="floatTickets"
//                   type="number"
//                   placeholder="Tickets"
//                   className={`form-control ${errors.tickets ? "is-invalid" : ""}`}
//                   {...register("tickets", { min: 1, required: true })}
//                 />
//                 <label htmlFor="floatTickets">No. of Ticket *</label>
//               </div>
//             </div>
//           </div>

//           {/* Payment Mode Selection */}
//           <div className="mb-4">
//             <label className="form-label small fw-bold">
//               Payment Mode <span className="text-danger">*</span>
//             </label>
//             <div className="row g-3">
//               <div className="col-md-4">
//                 <div
//                   className={`${styles.paymentOption} ${styles.walletMain} ${selectedPayment === "main_wallet" ? styles.active : ""}`}
//                   onClick={() => setValue("paymentMode", "main_wallet")}
//                 >
//                   Main Wallet Avail: ₹55,06,841
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div
//                   className={`${styles.paymentOption} ${styles.walletDiscount}`}
//                   style={{ opacity: 0.5, cursor: "not-allowed" }}
//                 >
//                   Discount Wallet Avail: ₹0
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div
//                   className={`${styles.paymentOption} ${styles.paymentOnline} ${selectedPayment === "online" ? styles.activeOnline : ""}`}
//                   onClick={() => setValue("paymentMode", "online")}
//                 >
//                   Online Payment
//                 </div>
//               </div>
//             </div>
//           </div>

//           <button type="submit" className={styles.reserveBtn}>
//             Reserve Your Seat
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EventRegistration;

import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./EventForm.module.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import useApiRequest from "../../Hooks/apiReq";
import BackButton from "../../Shared/BackButton";
import { useNavigate } from "react-router-dom";

const EventRegistration = () => {
  const { error, loading, recallRequest, response, sendApiRequest } =
    useApiRequest();
  const associateProfileDetails = useSelector(
    (state) => state.assoProfileDetails.profileDetails,
  );

  const navigate = useNavigate();

  const [dropData, setDropDownData] = useState([]);

  const getUpdatedEventlist = () => {
    sendApiRequest(
      "POST",
      "/Dashboard/GetEventList",
      {
        Mode: "EVENT_DDL",
      },
      {
        onSuccess: (res) => {
          const ParsedData = res?.data?.jsonData
            ? JSON.parse(res?.data?.jsonData)
            : [];
          setDropDownData(ParsedData);
        },
        onStatus3: () => navigate("/login"),
      },
    );
  };

  useEffect(() => getUpdatedEventlist(), []);

  const defaultValues = {
    name:
      (associateProfileDetails?.solutation || "") +
      " " +
      (associateProfileDetails?.fullName || ""),
    mobile: "9005756789",
    email: "vikramravgroup@gmail.com",
    tickets: 1,
    paymentMode: "main_wallet",
  };

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  const selectedPayment = watch("paymentMode");
  const selectedEventId = watch("event"); // Watch the selected event ID

  // Find the full event details based on the selected ID
  const selectedEventDetail = dropData?.find(
    (e) => String(e?.PkEventId) === String(selectedEventId),
  );

  const onSubmit = (data) => {
    console.log("Form Data Submitted:", data);
    sendApiRequest(
      "POST",
      {},
      {
        onSuccess: (res) => {
          toast.warn(res?.message || "Registration Reserved!");
        },
      },
    );
  };

  return (
    <div className="content">
      <div className={styles.cardContainer}>
        <BackButton onClick={() => navigate(-1)} />
        <h4 className="text-center mb-4 fw-bold">
          Fill the Details to Register for the Event
        </h4>

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Event Selection - Floating */}
          <div className="form-floating mb-4">
            <select
              id="eventSelect"
              {...register("event", { required: "Please select an event" })}
              className={`form-select ${errors.event ? "is-invalid" : ""}`}
            >
              <option value="">-- Select Event --</option>
              {dropData?.map((i) => (
                // Fixed: value must be the actual Event ID, not a hardcoded string
                <option key={i?.PkEventId} value={i?.PkEventId}>
                  {i?.strEventName} - {i?.EventCity} (
                  {i?.strEventDate?.split(" ")[0]})
                </option>
              ))}
            </select>
            <label htmlFor="eventSelect">
              Select Event to Register <span className="text-danger">*</span>
            </label>
            {errors.event && (
              <div className="invalid-feedback">{errors.event.message}</div>
            )}
          </div>

          {/* ATTRACTIVE EVENT DETAILS CARD (Shows only when an event is selected) */}
          {selectedEventDetail && (
            <div
              className="card border-0 mb-4 overflow-hidden"
              style={{
                // 1. Combine the gradient overlay and the image URL
                backgroundImage: `linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.9) 100%), url('https://erp.ravbiz.in/UploadFile/PropertyFile/LibraryFile/CPBanner_12032026183150.jpeg')`,

                // 2. Add these rules so the image fits perfectly
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",

                // 3. Keep your existing glassmorphism and borders
                backdropFilter: "blur(12px)",
                WebkitBackdropFilter: "blur(12px)",
                borderRadius: "16px",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
                border: "1px solid rgba(255, 255, 255, 0.05)",
              }}
            >
              <div className="card-body p-4">
                {/* Top Badges Row */}
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
                  <div className="d-flex gap-2">
                    <span
                      className="badge bg-light text-dark px-3 py-2 rounded-pill shadow-sm"
                      style={{ fontWeight: "600" }}
                    >
                      {selectedEventDetail?.strEventType || "Event"}
                    </span>
                    <span className="badge bg-secondary px-3 py-2 rounded-pill shadow-sm">
                      {selectedEventDetail?.EventCity}
                    </span>
                  </div>

                  {/* Seat Stats */}
                  <div className="d-flex gap-2 flex-wrap">
                    <span className="badge bg-primary px-3 py-2 rounded-pill shadow-sm">
                      Total Seats: {selectedEventDetail?.TotalSeat || 0}
                    </span>
                    <span className="badge bg-danger px-3 py-2 rounded-pill shadow-sm">
                      Booked: {selectedEventDetail?.BookedSeat || 0}
                    </span>
                    <span className="badge bg-success px-3 py-2 rounded-pill shadow-sm">
                      Available:{" "}
                      {(Number(selectedEventDetail?.TotalSeat) || 0) -
                        (Number(selectedEventDetail?.BookedSeat) || 0)}
                    </span>
                  </div>
                </div>

                {/* Event Name */}
                <h3
                  className="fw-bold text-white mb-3"
                  style={{ letterSpacing: "-0.5px" }}
                >
                  {selectedEventDetail?.strEventName}
                </h3>

                {/* Event Venue & Date */}
                <div className="d-flex flex-column gap-2 text-white-50">
                  <div className="d-flex align-items-center gap-2">
                    <span className="text-light">
                      {selectedEventDetail?.EventVenue}
                    </span>
                    {selectedEventDetail?.GoogleMap && (
                      <a
                        href={selectedEventDetail.GoogleMap}
                        target="_blank"
                        rel="noreferrer"
                        className="text-info text-decoration-none ms-2 badge border border-info rounded-pill px-2 py-1"
                        style={{ transition: "0.2s" }}
                      >
                        Find in Google ↗
                      </a>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2 mt-1">
                    <span className="text-light fw-medium">
                      {selectedEventDetail?.strEventDate}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <h5 className={styles.sectionTitle}>Primary Person Details</h5>

          <div className="row g-3 mb-4">
            {/* Name - Floating */}
            <div className="col-md-3">
              <div className="form-floating">
                <input
                  id="floatName"
                  readOnly
                  type="text"
                  placeholder="Name"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  {...register("name", { required: true })}
                />
                <label htmlFor="floatName">
                  Name <strong className="text-danger">*</strong>
                </label>
              </div>
            </div>

            {/* Mobile - Floating */}
            <div className="col-md-3">
              <div className="form-floating">
                <input
                  id="floatMobile"
                  type="tel"
                  placeholder="Mobile"
                  className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                  {...register("mobile", { required: true })}
                />
                <label htmlFor="floatMobile">
                  Mobile Number <strong className="text-danger">*</strong>
                </label>
              </div>
            </div>

            {/* Email - Floating */}
            <div className="col-md-4">
              <div className="form-floating">
                <input
                  id="floatEmail"
                  type="email"
                  placeholder="Email"
                  className="form-control"
                  {...register("email")}
                />
                <label htmlFor="floatEmail">Email</label>
              </div>
            </div>

            {/* No. of Tickets - Floating */}
            <div className="col-md-2">
              <div className="form-floating">
                <input
                  id="floatTickets"
                  type="number"
                  placeholder="Tickets"
                  className={`form-control ${errors.tickets ? "is-invalid" : ""}`}
                  {...register("tickets", { min: 1, required: true })}
                />
                <label htmlFor="floatTickets">
                  No. of Ticket <strong className="text-danger">*</strong>
                </label>
              </div>
            </div>
          </div>

          {/* Payment Mode Selection */}
          <div className="mb-4">
            <label className="form-label small fw-bold">
              Payment Mode{" "}
              <span className="text-danger">
                <strong className="text-danger">*</strong>
              </span>
            </label>
            <div className="row g-3">
              <div className="col-md-4">
                <div
                  className={`${styles.paymentOption} ${styles.walletMain} ${selectedPayment === "main_wallet" ? styles.active : ""}`}
                  onClick={() => setValue("paymentMode", "main_wallet")}
                >
                  Main Wallet Avail: ₹55,06,841
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className={`${styles.paymentOption} ${styles.walletDiscount}`}
                  style={{ opacity: 0.5, cursor: "not-allowed" }}
                >
                  Discount Wallet Avail: ₹0
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className={`${styles.paymentOption} ${styles.paymentOnline} ${selectedPayment === "online" ? styles.activeOnline : ""}`}
                  onClick={() => setValue("paymentMode", "online")}
                >
                  Online Payment
                </div>
              </div>
            </div>
          </div>

          <button type="submit" className={styles.reserveBtn}>
            Reserve Your Seat
          </button>
        </form>
      </div>
    </div>
  );
};

export default EventRegistration;
